import { render, staticRenderFns } from "./AddUserInfo.vue?vue&type=template&id=6dda9534"
import script from "./AddUserInfo.vue?vue&type=script&lang=js"
export * from "./AddUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports